import React from 'react'

import { times } from 'ramda'

import { ReactComponent as EngagementScoreFlame } from './flame.svg'

import styles from './styles.module.css'

const MAX_FLAMES = 5

export const EngagementScoreFlames = ({ score, emoji=false }: { score: number, emoji?: boolean }) => {
  if (score > MAX_FLAMES) score = MAX_FLAMES
  if (score < 0) score = 0
  const numberOfFlames = Math.min(Math.round(score), 5)

  return (
    emoji ? (
        <>
          {times(i => <span key={i} role="img" aria-label="flame">🔥</span>, numberOfFlames)}
        </> 
      ) : (
        <div className={styles.engagementScoreFlames}>
          {times(i => <EngagementScoreFlame key={i} />, numberOfFlames).concat(
              times(
                i => <EngagementScoreFlame key={i + 5} className={styles.off} />,
                MAX_FLAMES - numberOfFlames
              )
            )
          }
        </div>
      )    
  )
}
